import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

/**
 * Modal de Instrucciones de Conexión y Código QR para Ruleta Baja Cup (PersonalRoulette)
 * Permite al operador proyectar/mostrar el QR, copiar enlace directo o abrir la dinámica en nueva pestaña.
 */
export const PersonalRouletteInstructionsModal = ({
    isOpen,
    onClose,
    roomId = null,
    config = null,
    room = null
}) => {
    const [isCopied, setIsCopied] = useState(false);

    if (!isOpen) return null;

    const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
    const roomParam = roomId ? `&roomId=${roomId}` : '';

    const qrUrl = `${baseUrl}/psl-roulette?s=admin_qr${roomParam}`;
    const copyUrl = `${baseUrl}/psl-roulette?s=admin_copy${roomParam}`;
    const directUrl = `${baseUrl}/psl-roulette?s=admin_direct${roomParam}`;

    const handleCopy = async () => {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(copyUrl);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = copyUrl;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 2500);
        } catch (err) {
            console.error('Error al copiar la URL:', err);
        }
    };

    const primaryColor = config?.primaryColor || '#dc2626';
    const logoSrc = config?.logoUrl || '/img/page/xolos-five-bicolor.png';
    const roomDisplayName = room?.nombreSala || config?.titleEs || 'Ruleta Baja Cup';

    return (
        <>
            {/* Backdrop */}
            <div
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    zIndex: 110000,
                    backdropFilter: 'blur(4px)'
                }}
            />

            {/* Modal Card Centrada */}
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '95%',
                    maxWidth: '540px',
                    zIndex: 110001
                }}
            >
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden text-dark bg-white">
                    {/* Encabezado */}
                    <div
                        className="p-3 px-4 d-flex justify-content-between align-items-center text-white"
                        style={{ backgroundColor: primaryColor }}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <i className="bi bi-qr-code fs-4"></i>
                            <div>
                                <h5 className="mb-0 fw-bold">¡Gira la Ruleta Baja Cup!</h5>
                                <small className="opacity-75">{roomDisplayName} • Código QR Oficial</small>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={onClose}
                            aria-label="Cerrar"
                        ></button>
                    </div>

                    {/* Cuerpo */}
                    <div className="card-body p-4 text-center">
                        <p className="text-secondary fw-medium mb-3">
                            Escanea el código QR con la cámara de tu celular para registrarte y girar la ruleta:
                        </p>

                        {/* Contenedor del QR */}
                        <div className="d-flex justify-content-center mb-3">
                            <div className="p-3 bg-white border rounded-4 shadow-sm d-inline-block position-relative">
                                <QRCodeCanvas
                                    value={qrUrl}
                                    size={230}
                                    level="H"
                                    includeMargin={true}
                                    imageSettings={logoSrc ? {
                                        src: logoSrc,
                                        height: 48,
                                        width: 48,
                                        excavate: true
                                    } : undefined}
                                />
                            </div>
                        </div>

                        {/* Pasos rápidos para el operador */}
                        <div className="bg-light p-3 rounded-3 text-start small mb-3 border">
                            <div className="fw-bold text-dark mb-2 d-flex align-items-center gap-1">
                                <i className="bi bi-info-circle-fill text-primary"></i>
                                <span>Guía rápida para el operador:</span>
                            </div>
                            <div className="d-flex align-items-center gap-2 mb-1.5">
                                <span className="badge rounded-pill bg-danger" style={{ minWidth: '22px' }}>1</span>
                                <span className="text-dark">Proyecta o imprime este código QR en el stand o recinto.</span>
                            </div>
                            <div className="d-flex align-items-center gap-2 mb-1.5">
                                <span className="badge rounded-pill bg-danger" style={{ minWidth: '22px' }}>2</span>
                                <span className="text-dark">El aficionado escanea con su smartphone, completa el registro y gira.</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span className="badge rounded-pill bg-danger" style={{ minWidth: '22px' }}>3</span>
                                <span className="text-dark">Muestra su folio o cupón oficial en el Módulo para canjear su premio físico.</span>
                            </div>
                        </div>

                        {/* Caja de texto para copiar URL */}
                        <div className="mb-2 text-start">
                            <label className="form-label small fw-semibold text-secondary mb-1">
                                Enlace público directo para compartir:
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control form-control-sm bg-light font-monospace"
                                    value={copyUrl}
                                    readOnly
                                    onClick={(e) => e.target.select()}
                                />
                                <button
                                    type="button"
                                    className={`btn btn-sm ${isCopied ? 'btn-success text-white' : 'btn-outline-danger'} fw-semibold d-flex align-items-center gap-1`}
                                    onClick={handleCopy}
                                >
                                    {isCopied ? (
                                        <>
                                            <i className="bi bi-check2"></i>
                                            <span>¡Copiado!</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-clipboard"></i>
                                            <span>Copiar</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="card-footer bg-light p-3 px-4 d-flex justify-content-between align-items-center border-top">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm px-3"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger btn-sm px-3 fw-bold text-white d-flex align-items-center gap-2"
                            onClick={() => window.open(directUrl, '_blank')}
                        >
                            <i className="bi bi-box-arrow-up-right"></i>
                            <span>Abrir enlace directo</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PersonalRouletteInstructionsModal;
